// fetchCountries.js
import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { fetch_all_cities } from "../../endpoints/API";

export const fetchCities = async (setStates, baseUrl, prodTestUrl) => {
  try {
    const response = await fetch_all_cities();
    if (response.statusText=="OK") {
      const data = response?.data
      setStates(data);
    } else {
      message.error("Failed to fetch cities.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching cities.")
  }
};
